// Configurações centralizadas da aplicação
import packageJson from '../../package.json';

// Versão da aplicação (do package.json)
export const VERSION = packageJson.version;
export const VERSION_DESCRIPTION = import.meta.env.MODE || 'development';

// Outras configurações podem ser adicionadas aqui conforme necessário
